import { render, staticRenderFns } from "./article_stemp.vue?vue&type=template&id=4be4c00e&"
import script from "./article_stemp.vue?vue&type=script&lang=js&"
export * from "./article_stemp.vue?vue&type=script&lang=js&"
import style0 from "./article_stemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports